import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LISTING_STATUS_ACTIVE } from 'common/listingConstants';

import { getListingFullAddressString } from 'common/listingHelpers';

import {
  HOUSEHOLD_APPLICATION_STATUS_STARTED,
  HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
} from 'common/householdConstants';

class SrListingCardThumbnailHeader extends Component {
  static propTypes = {
    applicationStatus: PropTypes.string,
    listing: PropTypes.object,
    showListingAddress: PropTypes.bool,
    showApartmentUnit: PropTypes.bool,
    applicationStatusMessageOverride: PropTypes.string,
    disableDefaultApplicationStatusMessage: PropTypes.bool,
  };

  static defaultProps = {
    showListingAddress: false,
    disableDefaultApplicationStatusMessage: false,
  };

  render() {
    const {
      applicationStatus,
      listing,
      showListingAddress,
      showApartmentUnit,
      applicationStatusMessageOverride,
      disableDefaultApplicationStatusMessage,
    } = this.props;

    let message = null;

    if (applicationStatusMessageOverride) {
      message = applicationStatusMessageOverride;
    } else if (
      listing.status !== LISTING_STATUS_ACTIVE &&
      !disableDefaultApplicationStatusMessage
    ) {
      message = 'Not Available: Leased';
    } else if (
      applicationStatus === HOUSEHOLD_APPLICATION_STATUS_STARTED &&
      !disableDefaultApplicationStatusMessage
    ) {
      message = 'Application Started';
    } else if (
      applicationStatus === HOUSEHOLD_APPLICATION_STATUS_COMPLETED &&
      !disableDefaultApplicationStatusMessage
    ) {
      message = 'Application Submitted';
    }

    return (
      <div className="SrListingCardThumbnailHeader">
        <div className="thumbnailContainer">
          {showListingAddress && (
            <span className="listingAddress">{getListingFullAddressString(listing)}</span>
          )}
          {showApartmentUnit && (
            <span className="listingAddress">{`Unit ${listing.apartmentUnit}`}</span>
          )}
          {message && <div className="message">{message}</div>}
        </div>
      </div>
    );
  }
}

SrListingCardThumbnailHeader.displayName = 'SrListingCardThumbnailHeader';

export default SrListingCardThumbnailHeader;
